import script from "./EventsView.vue?vue&type=script&setup=true&lang=js"
export * from "./EventsView.vue?vue&type=script&setup=true&lang=js"

import "./EventsView.vue?vue&type=style&index=0&id=84726296&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84726296"]])

export default __exports__